import { useQuery } from '@apollo/client';
import { ENTITY_TYPE } from '@nile/client_management/src/Contracts/Constants';
import {
  ASSET_FILTER,
  REQUESTER_FILTER,
  SITE_FILTER
} from '@nile/client_management/src/Contracts/DeliveryMap/ChildGroup/helpers';
import { FilterSection as AdvancedFilter } from '@nile/components/src/Components/AdvancedFilter';
import { AccountClient } from '@nile/graphql';
import { GET_PROVISION_RULE_CONDITION_META } from '@nile/graphql/src/Query/contracts';
import { TextStyle } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDeliveryMapContext } from '../../Contexts/DeliveryMapContext';
import { COMMON_CONSTANTS, Loader } from '@nile/components';
import { Error } from '@nile/components/src/Utils/helpers';

const ENTITY_TO_MODULE_MAP = {
  [ENTITY_TYPE.ASSETS]: 'Asset',
  [ENTITY_TYPE.SITE]: 'site',
  [ENTITY_TYPE.REQUESTER]: 'ClientUser'
} as const;

const ENTITY_HELPER = {
  [ENTITY_TYPE.ASSETS]: ASSET_FILTER,
  [ENTITY_TYPE.SITE]: SITE_FILTER,
  [ENTITY_TYPE.REQUESTER]: REQUESTER_FILTER
} as const;

export function ProvisionRuleBuilder(props: {
  updateCondition: (arg0: any) => void;
  conditions: any;
  ruleEntityType: ENTITY_TYPE;
  errors: any;
}) {
  const { updateCondition, conditions, ruleEntityType, ...rest } = props;

  const { client, isTemplate } = useDeliveryMapContext();

  const { loading, error, data } = useQuery(GET_PROVISION_RULE_CONDITION_META, {
    client: AccountClient,
    variables: {
      input: { isTemplate, ruleEntityType }
    },
    fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE
  });

  if (loading) return <Loader />;
  if (error) return <div>error...</div>;

  return (
    <div>
      <AdvancedFilter
        listMeta={{
          conditionAttributes: data?.getProvisionRuleConditionMeta?.variables
        }}
        currentModule={ENTITY_TO_MODULE_MAP[ruleEntityType]}
        conditions={conditions}
        onAttributeSelect={(p: any) =>
          ENTITY_HELPER[ruleEntityType].onAttributeSelect(p, client?.accountId)
        }
        onValueSearch={(...args: Array<any>) =>
          ENTITY_HELPER[ruleEntityType].onValueSearch(
            ...args,
            client?.accountId
          )
        }
        handleDone={updateCondition}
        renderOnlyFilterSection
        isNewBuilder
        {...rest}
      >
        {typeof rest.errors?.[0] === 'string' && (
          <Error>{rest.errors?.[0]}</Error>
        )}
      </AdvancedFilter>
    </div>
  );
}
